const AppointmentsRenderCalendar = ({
  date,
  onSelectDateRange,
  selectDates,
  setFilterValue,
  filterValue,
}) => {
  const daysInMonth = new Date(
    date.getFullYear(),
    date.getMonth() + 1,
    0
  ).getDate();
  const firstDayOfMonth = new Date(
    date.getFullYear(),
    date.getMonth(),
    1
  ).getDay();
  const today = new Date();

  const dates = [];
  let startSelection = selectDates?.[0] ? new Date(selectDates[0]) : null;
  let endSelection = selectDates?.[1] ? new Date(selectDates[1]) : null;

  const selectDate = (currentDate) => {
    setFilterValue({
      ...filterValue,
      datefilter: 'Custom',
    });
    if (!startSelection || (startSelection && endSelection)) {
      startSelection = currentDate;
      endSelection = null;
    } else {
      endSelection = currentDate;
    }
    onSelectDateRange(startSelection, endSelection);
  };

  for (let i = 1; i <= daysInMonth; i++) {
    const currentDate = new Date(date.getFullYear(), date.getMonth(), i);
    let className = 'calendar-day';

    if (startSelection && endSelection) {
      if (currentDate.getTime() === startSelection.getTime()) {
        className += ' selected-start';
      } else if (currentDate.getTime() === endSelection.getTime()) {
        className += ' selected-end';
      } else if (currentDate > startSelection && currentDate < endSelection) {
        className += ' selected-middle';
      }
    } else if (
      startSelection &&
      currentDate.getTime() === startSelection.getTime()
    ) {
      className += ' selected-start';
    }

    if (currentDate.toDateString() === today.toDateString()) {
      className += ' current-date';
    }

    if (startSelection && !endSelection && currentDate < startSelection) {
      className += ' disabled';
    }

    if (endSelection) {
      className = className.replace('disabled', '');
    }

    dates.push(
      <div
        key={currentDate}
        className={className}
        onClick={() => selectDate(currentDate)}
      >
        {i}
      </div>
    );
  }

  // Empty divs to fill up the grid until the first day of the month
  for (let i = 0; firstDayOfMonth > 0 && i < firstDayOfMonth; i++) {
    dates.unshift(
      <div key={`empty-${i}`} className="calendar-day empty"></div>
    );
  }

  return (
    <div className="calendar">
      <div className="calendar-grid">
        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
          <div className="calendar-day-name" key={day}>
            {day}
          </div>
        ))}
        {dates}
      </div>
    </div>
  );
};

export default AppointmentsRenderCalendar;
